window.addEventListener('load', function() {
    if ( jQuery('#lesson-complete').length ) {
        var target = jQuery('#lesson-complete');
        var posi = target.offset().top;
        jQuery('html,body').animate({
          'scrollTop': posi
        }, 500);
    }
});
